
$(document).on('ready', function() {
    // Function to perform the AJAX call
    function getMarketData() {
        $.post(ajax_global.url, {
            action: "get_market_data"
        }).done(function(r) {
            
            if (r.success) {
                // console.log(r);
                html = r.data.html;

                // Update the table
                $('#markets-table tbody').html(html);
            } else {
                // console.log(r);
                $('#markets-table tbody').html('<tr><td colspan="6">Data unavailable</td></tr>')
            }
        });
    }

    // Fire the AJAX call on page load
    if($('#markets-table').length) {
        getMarketData();

        // Set up an interval to repeat the AJAX call every minute
        setInterval(getMarketData, 60000); // 60000 milliseconds = 1 minute
    }
});